export const GET_SAVE_DEFAULT_LOCATION = 'GET_SAVE_DEFAULT_LOCATION';
export const SET_IS_SAVE_DEFAULT_LOCATION = 'SET_IS_SAVE_DEFAULT_LOCATION';
